import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Flex, Form, TextArea, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useBusinessDisabled } from "@/mobile/Settings/Business/Edit/utils/useBusinessDisabled";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsBusinessAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditBusinessDescription: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const businessDescriptionApi = useAppSelector((state) => state.user.businessInfo?.businessDescription);
  const isBusinessDisabled = useBusinessDisabled();

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        placement={"bottom"}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.description")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <Form
            onFinish={({ businessDescription }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.state.url,
                fieldName: "businessDescription",
                fieldValue: businessDescription,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ businessDescription: mobileFormEditState.businessDescription ?? businessDescriptionApi }}
          >
            <Form.Item
              label={t("settings.business.description")}
              name="businessDescription"
              rules={[
                { required: true, message: t("common.required") },
                { min: 20, message: t("settings.business.errors.minDescription") },
              ]}
            >
              <TextArea disabled={isBusinessDisabled} />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>
            {t("settings.business.instructions.businessDescription")}
          </Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessDescription;
